<template>
  <div class="Forms">


    <template v-if="initialized">

      <Form 
      :ref="pos" 
      :key="pos" v-for="(shape, pos) in shapes" :data="shape" 
      :indice="pos" 
      level="second"/>

      <Pusher indice="left" level="second"/>
      <Pusher indice="right" level="second"/>

    </template>


  <!--    <Form :ref="index" :key="index" v-for="(shape, index, pos) in shapes" :data="shape" :indice="pos" level="second" v-if="initialized"/> -->


  </div>
</template>

<script>

import gsap from "gsap"
import ConstMatter from '@/core/mixins/ConstMatterPixi'
import Matter from 'matter-js'
import Form from './Form.vue'
import Pusher from './Pusher.vue'
import Settings from './Settings'

export default {
  name: 'Forms',
  mixins: [ ConstMatter ],
  components: { Form, Pusher },
  data: () => ({
    initialized: false,
    shapes: [],
    test: []
  }),
  beforeDestroy() {},
  created() {
    this.$center = { x: window.innerWidth/2, y: window.innerHeight/2 }
  },

  mounted() {

    this.$loop = 1
    this.$delete = 3.2

    if(!this.$debug) {
        this.$container = new PIXI.Container()
        this.$parent.$forms.addChild(this.$container)
    }
    this.initialized = true


    // gsap.delayedCall(this.$loop, ()=> this.addForm())
    // gsap.delayedCall(this.$delete, ()=> this.removeForm())



  },

  methods: {

    addForm() {

      const form = Settings[_.random(0,5)]
      

      // this.test.push(form.key+ '_'+ this.test.length)

      // console.log(this.test);

      this.shapes.push(form)
      this.$tw = gsap.delayedCall(this.$loop, ()=> this.addForm())

      // console.log(this.shapes.length);


    },


    removeForm() {

      

      this.shapes = this.shapes.splice(this.shapes.length-1, 1)

      // console.log(' = '+ this.shapes.length);

      // this.test = this.test.splice(this.test.length-1,1)
      // console.log('xxxxxx -- ');


      gsap.delayedCall(this.$delete, ()=> this.removeForm())

    },



    getX(val){
      return this.$center.x + ((window.innerWidth*val)/2)
    },
    getY(val){
      return this.$center.y + ((window.innerHeight*val)/2)
    },

  },

  // computed: {
  //   shapes() { return this.$store.getters['data/shapes'] }
  // }

}

</script>
